import { Record, List, fromJS } from 'immutable';
import CurrencyUtilities from 'records/CurrencyUtilities';

const contentFileApi = {
  contentName: 'Default Menu Item Image',
  contentUrl: null,
  createBy: 0,
  createTime: null,
  description: 'Menu Item Image',
  dimensions: [
    {
      length: 0,
      units: 0,
      width: 0,
    },
  ],
  id: 0,
  sizes: [
    {
      size: 0,
      type: 0,
      units: 0,
    },
  ],
};

const defaultValues = {
  id: null,
  menuId: null,
  layerId: null,
  categoryId: null,
  userCategoryId: null,
  designKey: null, // used to map design items
  archived: false,
  createdBy: null,
  created: null,
  updatedBy: null,
  updated: null,
  title: '',
  description: '',
  sizeTextKey: null,
  numberPieces: 0,
  spiceLevel: 0,
  price: 0,
  cost: 0,
  spiceLevelTextKey: null,
  formatting: null,
  contentFileApi: fromJS(contentFileApi),
  file: null,
  ordinal: 0,
  recipes: new List(),
  images: new List(),
  itemProfit: 0,
  costPercentage: 0,
  suggestedPrice: 0,
  overrided: false,
};

export default class MenuItem extends Record(defaultValues, MenuItem) {
  constructor(values) {
    super({
      ...values,
      price: values && values.price
            ? CurrencyUtilities.currencyFormat(values.price) : defaultValues.price,
      cost: values && values.cost
            ? CurrencyUtilities.currencyFormat(values.cost) : defaultValues.cost,
      contentFileApi: values && values.contentFileApi
                      ? fromJS(values.contentFileApi) : defaultValues.contentFileApi,
      recipes: values && values.recipes ? fromJS(values.recipes) : defaultValues.recipes,
      images: values && values.images ? fromJS(values.images) : defaultValues.images,
      itemProfit: values && values.itemProfit
            ? CurrencyUtilities.currencyFormat(values.itemProfit) : defaultValues.itemProfit,
      suggestedPrice: values && values.suggestedPrice
            ? CurrencyUtilities.currencyFormat(values.suggestedPrice) : defaultValues.suggestedPrice,
    });
  }

  setMenuItemByKey(key, value) {
    return this.set(`${ key }`, value);
  }

  static getActiveMenuItems(menusItems) {
    return menusItems.filter((menusItem) => {
      return menusItem.get('archived') === false;
    });
  }

  static getArchivedMenuItems(menuItems) {
    return menuItems.filter((menuItem) => {
      return menuItem.get('archived') === true;
    });
  }

  static addMenuItem(menuItems, menuItem) {
    return menuItems.push(menuItem);
  }

  static getMenuItemIndexById(menuItems, id) {
    return menuItems.findIndex(item => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static getMenuItemById(menuItems, id) {
    return menuItems.find(item => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static updateMenuItemsIndex(menuItems, index, menuItem) {
    return menuItems.set(index, menuItem);
  }

  static mergeMenuItemsById(oldMenuItems, newMenuItems) {
    let menuItemsData = oldMenuItems;
    newMenuItems.forEach((item) => {
      const itemIndex = MenuItem.getMenuItemIndexById(menuItemsData, item.get('id'));
      if (itemIndex >= 0) {
        menuItemsData = MenuItem.updateMenuItemsIndex(menuItemsData, itemIndex, item);
      } else {
        menuItemsData = menuItemsData.push(item);
      }
    });
    return menuItemsData;
  }

  static filterByCategoryId(menusItems, id) {
    return menusItems.filter((menusItem) => {
      return menusItem.get('userCategoryId') === id;
    });
  }

  static deleteMenuItemByIndex(menuItems, index) {
    return menuItems.delete(index);
  }

  static insertMenuItemByIndex(menuItems, index, menuItem) {
    return menuItems.insert(index, menuItem);
  }

  static sortMenuItemsByOrdinal(menuItems) {
    return menuItems.sort((itemOne, itemTwo) => {
      if (itemOne.get('ordinal') < itemTwo.get('ordinal')) return -1;
      if (itemOne.get('ordinal') > itemTwo.get('ordinal')) return 1;
      return 0;
    });
  }

  static updateMenuItemOrdinalsFromIndex(menuItems) {
    return menuItems.map((item, index) => {
      return item.set('ordinal', index);
    });
  }

  static getNextOrdinal(menuItems) {
    const items = this.sortMenuItemsByOrdinal(menuItems);
    const item = items.last();
    if (item) {
      return item.get('ordinal') + 1;
    }
    return 0;
  }

  static formatMenuItemsForOrdinalUpdate(menuItems) {
    const menuItemData = {
      ids: [],
    };
    menuItems.forEach((item) => {
      menuItemData.ids.push(item.get('id'));
    });
    return menuItemData;
  }
}

export const MenuItems = (data) => {
  let menusItems = new List();
  if (data) {
    data.forEach((value) => {
      menusItems = menusItems.push(new MenuItem(value));
    });
  }
  return menusItems;
};
